import React from "react";
import {
  StyledChoiceFileText,
  StyledContainerBox,
  StyledUploadBox,
} from "./style";
import { useState } from "react";
import { FormHelperText, TextField } from "@mui/material";
import { ImUpload } from "react-icons/im";
import Toast from "helper/toast";
import { theme } from "styles/mui-config";
export default function FileUploadInputCm({
  id = "file",
  title = "آپلود فایل",
  register,
  file_formats = [],
  limit = 10,
}) {
  const [file, setFile] = useState();
  const [error, setError] = useState({
    hasError: false,
    error: "",
  });

  const changeFileHandle = (event) => {
    const file = event.target.files[0];
    const file_type = /[^.]+$/.exec(file.name)[0];
    const format = file_formats.find((item) => item === file_type);
    setFile(file.name);

    if (!file_type || !format) {
      // Toast({
      //   type: "custom-warn",
      //   title: `فرمت نامعبتر است. (${file_formats.join()})`,
      //   autoClose: 4000,
      // });

      setError({
        error: `فرمت نامعبتر است. (${file_formats.join()})`,
        hasError: true,
      });

      return false;
    }
    if (file.size > limit * 10_000_000) {
      // Toast({
      //   type: "custom-warn",
      //   title: `حجم  باید کمتر از ${limit}  مگ باشد`,
      //   autoClose: 4000,
      // });

      setError({
        error: "حجم فایل زیاد است",
        hasError: true,
      });

      return false;
    } else {
      setError({
        error: "",
        hasError: false,
      });
    }
  };

  return (
    <>
      <StyledContainerBox>
        <StyledUploadBox>
          <StyledChoiceFileText>{file ? file : title}</StyledChoiceFileText>
          <ImUpload />
        </StyledUploadBox>
        <TextField
          variant="outlined"
          type="file"
          fullWidth
          id="id"
          {...register(id)}
          onChange={(e) => changeFileHandle(e)}
          error={Boolean(error.hasError)}
        />
      </StyledContainerBox>
      {Boolean(error.hasError) ? (
        <FormHelperText sx={{ color: theme.palette.error.main }}>
          {error?.error}
        </FormHelperText>
      ) : (
        ""
      )}
    </>
  );
}
